module.exports = __webpack_public_path__ + "img/box_anim_bk2.f6a21279.png";